import axios from "axios";
import { handleApiError } from "src/common/api/apiErrorHandler";
import { SurveyLink } from "../types/surveyLink";

export default class SurveyLinksApi {
  static async getLink(publicKey: string): Promise<SurveyLink> {
    const url = this.baseUrl + `/s/${publicKey}`;
    try {
      const response = await axios.get<SurveyLink>(url);
      return response.data;
    } catch (error) {
      return handleApiError(error);
    }
  }

  private static baseUrl: string = "./api/links/survey";
}
